import React from 'react'
import type {IpiVisScorecards as Scorecards} from './_requests'

type Props = {
  data: Scorecards
  onViewOpen: () => void
  onViewCritical: () => void
}

export const IpiVisScorecards: React.FC<Props> = ({data, onViewOpen, onViewCritical}) => {
  return (
    <>
      <div className='ipivis-card ipivis-scorecard ipivis-scorecard--open'>
        <span className='ipivis-scorecard__label'>Open Appointments</span>
        <div className='ipivis-scorecard__body'>
          <span className='ipivis-scorecard__value'>{data.openAppointments.toLocaleString()}</span>
          <span className='ipivis-scorecard__sub'>All Open Jobs</span>
          <button
            className='ipivis-scorecard__cta ipivis-scorecard__cta--olive'
            onClick={onViewOpen}
            type='button'
          >
            View Assignments
          </button>
        </div>
      </div>

      <div className='ipivis-card ipivis-scorecard ipivis-scorecard--success'>
        <span className='ipivis-scorecard__label'>Fulfillment Rate</span>
        <div className='ipivis-scorecard__body'>
          <span className='ipivis-scorecard__value'>{data.fulfilmentRate}%</span>
          <div className='ipivis-scorecard__metrics'>
            <p>Total: {data.totalAppointments.toLocaleString()}</p>
            <p>Completed/Confirmed: {data.completedConfirmed.toLocaleString()}</p>
            <p>Abandoned/Cancelled: {data.abandonedCancelled.toLocaleString()}</p>
          </div>
        </div>
      </div>

      <div className='ipivis-card ipivis-scorecard ipivis-scorecard--danger'>
        <span className='ipivis-scorecard__label'>
          Critical Open(<span className='ipivis-scorecard__label-thin'>≤ 24hrs</span>)
        </span>
        <div className='ipivis-scorecard__body'>
          <span className='ipivis-scorecard__value ipivis-scorecard__value--danger'>
            {data.criticalOpen24h.toLocaleString()}
          </span>
          <button
            className='ipivis-scorecard__cta ipivis-scorecard__cta--danger'
            onClick={onViewCritical}
            type='button'
          >
            View Assignments
          </button>
        </div>
      </div>
    </>
  )
}
